import React, {useEffect, useState} from 'react';
import {FormGroup, CustomInput, Button} from 'reactstrap';

import {FormOtp, FormSubmit} from 'components/Forms';

import Login2FAAnotherMethod from './Login2FAAnotherMethod';
import useVerifyAuth from './useVerifyAuth';
import MuiIcon from 'components/Icons/MuiIcon';

const CODE_LENGTH = 6;

function Login2FAAuthenticator(props) {
  const {session, enabledEmail, enabledAltEmail, onShowEmail, onShowAltEmail} =
    props;
  const {two_factor_session_id} = session || {};

  const [showAnother, setShowAnother] = useState(false);
  const [states, setStates] = useState({
    secret: '',
    remember_device: false,
  });

  // cleanup
  useEffect(() => {
    return () => {
      setStates({
        secret: '',
        remember_device: false,
      });
      setShowAnother(false);
    };
  }, []);

  const {isVerifying, onVerify} = useVerifyAuth();

  function handleCodeChange(value) {
    setStates((prevStates) => ({...prevStates, secret: value || ''}));
  }

  function handleRememberChange(e) {
    const {checked} = e.target;
    setStates((prevStates) => ({...prevStates, remember_device: checked}));
  }

  const {secret} = states;

  if (showAnother) {
    return (
      <Login2FAAnotherMethod
        session={session}
        enabledEmail={enabledEmail}
        enabledAltEmail={enabledAltEmail}
        onShowEmail={onShowEmail}
        onShowAltEmail={onShowAltEmail}
        onBack={() => setShowAnother(false)}
      />
    );
  }

  return (
    <React.Fragment>
      <div className="text-center">
        <h1>2-Factor Authentication:</h1>
        <h1>Authenticator</h1>
        <p className="text-muted mb-0">
          Enter the code generated from your authenticator in the field below
        </p>
      </div>

      <FormSubmit
        onSubmit={() => onVerify({...states, two_factor_session_id})}
        isSubmitting={isVerifying}
      >
        <fieldset disabled={isVerifying}>
          <FormOtp onChange={handleCodeChange} className="mb-4" />

          <FormGroup>
            <CustomInput
              id="remember"
              type="checkbox"
              label="Remember this device for 30 days"
              onChange={handleRememberChange}
            />
          </FormGroup>

          <Button
            block
            type="submit"
            color="primary"
            className="mb-3"
            disabled={isVerifying || secret.length < CODE_LENGTH}
          >
            {isVerifying ? (
              'Verifying...'
            ) : (
              <span>
                Continue <MuiIcon name="chevron_right" />
              </span>
            )}
          </Button>
        </fieldset>
      </FormSubmit>

      <div className="text-center">
        <p>
          <span
            className="btn-link font-weight-normal"
            style={{cursor: 'pointer'}}
            onClick={() => setShowAnother(true)}
          >
            Try another method
          </span>
        </p>
      </div>
    </React.Fragment>
  );
}

export default Login2FAAuthenticator;
